export const INTRO_PHRASES = {
    BOX_1_TITLE: 10661,
    BOX_1_TEXT: 10662,
    BOX_2_TITLE: 10663,
    BOX_2_TEXT: 10664,
    BOX_3_TITLE: 10665,
    BOX_3_TEXT: 10666,
    BOX_4_TITLE: 10667,
    BOX_4_TEXT: 10668,
    BOX_5_TITLE: 10669,
    BOX_5_TEXT: 10670,
    BOX_6_TITLE: 10671,
    BOX_6_TEXT: 10672,
    INTRO_BANNER: 19700,
    INTTRO_BANNER_LINK: 19701,
};
